import { useEffect, useState } from "react";
import { Info, Search } from "react-feather";
import { getAgreementDataById, getAgreementSearchData } from "../../api/agreementRequest";
import { getBulkDropdownData } from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SideDrawer from "../../components/input/SideDrawer";
import AggreementAddComponent from "../../components/master/AgreementAddComponent";
import { ActiveCellStyle, ResizableScrollingTextRenderer, StatusCellStyle, } from "../../components/renderer/StyleRenderer";
import { activeById, FORMS, MODULES, statusById } from "../../const";
import { formatFromJsonDate, formatToDateOnlyFromJsonDate, } from "../../dateConfig";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";

function Agreements() {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.AGREEMENT,
  });
  const [tab, setTab] = useState(1);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [searchClicked, setSearchClicked] = useState(false);
  const [agreementData, setAgreementData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [formData, setFormData] = useState({
    code: "",
    category: null,
    name: "",
    status: null,
    fromDate: "",
    toDate: "",
  });

  // dropdown data
  const [currentErrors, setCurrentErrors] = useState({});

  const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOptions, setActiveTypeOptions] = useState([]);

  const [editAgreement, setEditAgreement] = useState({});
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const [resetNeeded, setResetNeeded] = useState(false);

  console.log(agreementData);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new
      const {
        agreement: agreementOpt = [],
        status = [],
        active = [],
        doc_type: docTypeOpt = [],
      } = await getBulkDropdownData([
        { key: "agreement" },
        { key: "status" },
        { key: "active" },
        { key: "doc_type" },
      ]);

      setCategoryTypeOptions(agreementOpt);
      setStatusOpt(status);
      setDocumentTypeOptions(docTypeOpt);
      setActiveTypeOptions(active);

      setIsLoading(false);
    })();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Add this function to handle date inputs
  const handleDateChange = (date, name) => {
    setFormData({
      ...formData,
      [name]: date,
    });
  };

  const handleReset = () => {
    setFormData({
      code: "",
      category: null,
      name: "",
      status: null,
      fromDate: "",
      toDate: "",
    });
    setSearchClicked(false);
  };

  const handleSearch = async () => {
    setIsLoading(true);
    setSearchClicked(false);

    try {
      console.log("search formData: ", formData);
      const data = await getAgreementSearchData(formData);

      const mappedResponse = await Promise.all(
        data.map(async (item) => ({
          ...item,
          agrStatusValue: statusById[item.agrStatus],
          agrActiveValue: activeById[item.agrActive],
          agrFromDateValue: item.agrFromDate
            ? formatToDateOnlyFromJsonDate(item.agrFromDate)
            : "",
          agrToDateValue: item.agrToDate
            ? formatToDateOnlyFromJsonDate(item.agrToDate)
            : "",
        })),
      );


      const filtered = mappedResponse.filter((item) => {
        const codeMatch = formData.code
          ? (item.agrCode || "").toLowerCase().includes(formData.code.toLowerCase())
          : true;
        const nameMatch = formData.name
          ? (item.agrName || "").toLowerCase().includes(formData.name.toLowerCase())
          : true;

        const categoryMatch = formData.category
          ? item.agrCategory == formData.category
          : true;
        const statusMatch = formData.status
          ? item.agrStatus == formData.status
          : true;
        // Date range filtering
        const fromDateMatch = formData.fromDate
          ? new Date(item.agrFromDate) >= new Date(formData.fromDate)
          : true;
        const toDateMatch = formData.toDate
          ? new Date(item.agrToDate) <= new Date(formData.toDate)
          : true;
        return codeMatch && nameMatch && categoryMatch && statusMatch && fromDateMatch && toDateMatch;
      });

      setAgreementData(filtered);
      setActiveAccordion(false);
      setSearchClicked(true);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (updateNeeded) {
      handleSearch();
      setUpdateNeeded(false);
    }
  }, [updateNeeded]);

  const handleDrawerOpen = () => {
    setEditAgreement({});
    setDrawerOpen(true);
    setEditMode(false);
    setTab(1);
    setResetNeeded(true);
  };

  const handleDrawerClose = () => {
    setResetNeeded(true);
    setDrawerOpen(false);
  };

  const handleAccordionClick = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <div className="ui top attached tabular menu">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Info size={15} style={{ marginRight: "5px" }} />
            </span>
            Agreement
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0px",
          }}
          className="ui tabular menu top attached"
        >
          <Button
            template="drawerOpen"
            disabled={firstViableTab === -1}
            onClick={handleDrawerOpen}
            authenticated={true}
            form={FORMS.AGREEMENT.AGR.form}
            module={MODULES.Master}
            editMode={false}
          />
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion === 1 ? "active" : ""}`}
            onClick={() => handleAccordionClick(1)}
          >
            <div>
              Search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
            <div className="ui form">
              <h4 className="ui dividing header">Agreement Information</h4>
              <div className="field">
                <div className="three fields">
                  <Input
                    label="Agreement Code"
                    error={currentErrors.code}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { code: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    name="code"
                    placeholder="Agreement Code"
                    value={formData.code}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, code: e.target.value }))
                    }
                  />

                  <Dropdown
                    label="Category"
                    error={currentErrors.category}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { category: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    clearable
                    placeholder="Category"
                    style={{ height: "5px" }}
                    options={categoryTypeOptions}
                    value={formData.category}
                    onChange={(e, data) => {
                      setFormData({
                        ...formData,
                        category: data.value,
                      });
                    }}
                  />

                  <Input
                    label="Name"
                    error={currentErrors.name}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { name: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    name="name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, name: e.target.value }))
                    }
                  />
                </div>
                <div className="three fields">
                  <Input
                    label="From Date"
                    error={currentErrors.fromDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { fromDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={(e) =>
                      handleDateChange(e.target.value, "fromDate")
                    }
                  />

                  <Input
                    label="To Date"
                    error={currentErrors.toDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { toDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="date"
                    name="toDate"
                    value={formData.toDate}
                    onChange={(e) => handleDateChange(e.target.value, "toDate")}
                  />

                  <Dropdown
                    label="Status"
                    error={currentErrors.status}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { status: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    clearable
                    placeholder="Status"
                    options={statusOpt}
                    style={{ height: "5px" }}
                    value={formData.status}
                    onChange={(e, data) => {
                      setFormData({
                        ...formData,
                        status: data.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={handleSearch} />
                    <Button template="searchReset" onClick={handleReset} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          searchClicked && (
            <Grid // Display grid if not loading and search has been clicked
              content={agreementData}
              showDownloadButton={true}
              downloadParam={""}
              downloadAction="Agreement Excel Download"
              downloadOnlySelected={true}
              excelSheetDownload={true}
              multiRowSelection={true}
              reportName="agreements_report"
              config={[
                {
                  headerName: "Code",
                  field: "agrCode",
                  checkboxSelection: true,
                  headerCheckboxSelection: true,
                },
                { headerName: "Category", field: "agrCategoryName" },
                {
                  headerName: "Name",
                  field: "agrName",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  headerName: "From",
                  field: "agrFromDateValue",
                  minWidth: 230,
                },
                { headerName: "To", field: "agrToDateValue", minWidth: 230 },
                {
                  headerName: "Status",
                  field: "agrStatusValue",
                  cellRenderer: StatusCellStyle,
                },
                {
                  headerName: "Active",
                  field: "agrActiveValue",
                  cellRenderer: ActiveCellStyle,
                },
              ]}
              onCellDoubleClicked={async (props) => {
                console.log("props: ", props.data);
                const response = await getAgreementDataById(
                  props.data.agr_id || props.data.agrId,
                );
                setEditAgreement(response);
                setDrawerOpen(true);
                setEditMode(true);
              }}
            />
          )
        )}
      </div>

      {/* Side Drawer */}
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div className="drawer-header">
              <div style={{ padding: "10px 16px" }}>
                <h3>
                  Edit Agreement: {editAgreement?.agreementResponse?.agrCode}
                </h3>
              </div>
            </div>
          ) : null
        }
        body={
          <AggreementAddComponent
            editAgreement={editAgreement}
            documentTypeOptions={documentTypeOptions}
            editMode={editMode}
            setUpdateNeeded={setUpdateNeeded}
            resetNeeded={resetNeeded}
            setResetNeeded={setResetNeeded}
            onClose={handleDrawerClose}
          />
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
}

export default Agreements;
